/**
 * Скрипты главной страницы
 */
(function(){

  // Основной слайдер
  var mainSlider = new Swiper('.main-slider', {
    loop: true,
    pagination: {
      el: '.main-slider-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.main-slider-next',
      prevEl: '.main-slider-prev',
    }
  });

  // Слайдер партнеров
  var mainSlider = new Swiper('.partners-slider', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 30,
    speed: 500,
    autoplay: {
      delay: 1000,
    },
    freeMode: true,
    breakpoints: {
      992: {
        slidesPerView: 7,
      }
    }
  });

})();